import React from 'react'

const AgainstProductSocialMedia = () => {
  return (
    <div className='grid'>
    <div className='md:col-12'>
       
        <div className='' style={{width:'100%',height:'50vh'}}  >
        <p style={{fontWeight:'bold',margin:'0px'}}>Z-Products-Sponsor</p>
        <p style={{margin:'0px'}}>24 March 2024 11:29AM</p>
        <p style={{fontWeight:'bold'}}>Description</p>
        <img src={ 'assets/layout/images/banner-primeblocks-dark.png' } style={{width:'100%',height:'45vh'}} alt="logo"/>
        </div>
    </div>
</div>
  )
}

export default AgainstProductSocialMedia